import React, { useEffect, useState } from 'react';
import { DatePicker, Form } from 'antd';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import moment from 'moment';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { useSelector } from 'react-redux';
import { setDate } from '../../../slices/dateSlice';
import "../../css/Range.css";
dayjs.extend(customParseFormat);
const { RangePicker } = DatePicker;

const DateRange = () => {
  const { date } = useSelector((state) => state.date);
  const dispatch = useDispatch();
  const dateFormat = 'YYYY-MM-DD';

  const [dates, setDates] = useState([
    dayjs(moment(date?.startDate).format('YYYY-MM-DD'), dateFormat),
    dayjs(moment(date?.endDate).format('YYYY-MM-DD')),
  ]);

  const handleChange = (e) => {
    if (e != null) {
      setDates({ startDate: e[0].$d, endDate: e[1].$d });
      dispatch(setDate({ startDate: e[0].$d.toISOString(), endDate: e[1].$d.toISOString() }));
    } else {
      dispatch(setDate({ startDate: null, endDate: null }));
    }
  };

  return (
    <RangePicker
      defaultValue={dates}
      onChange={(e) => handleChange(e)}
      style={{ width: '100%' }} // Responsive
      getPopupContainer={(trigger) => trigger.parentNode} // Ensures calendar stays within screen
      popupClassName="responsive-calendar" // Optional: use if needed for further styling
    />
  );
};

export default DateRange;
